module.exports = __webpack_public_path__ + "static/img/biobank-2.47db31408e1e008b202526e3339b59c6.png";